import type { CloudName } from '@atlassian/jira-shared-types/src/general.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useCloudName = (): CloudName => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.cloudName;
};
